import { useToastContext } from './ToastProvider';

export const useToast = () => {
  const { showToast, hideToast } = useToastContext();
  return {
    showSuccess: (msg: string) => showToast(msg, 'success'),
    showError: (msg: string) => showToast(msg, 'error'),
    hideToast,
  };
};
